
<div class="row">
  <div class="col-6">

    <div class="card">
      <div class="card-body">
        <h5 class="card-title">{{ 'PRODUCT_STATISTICS.PRODUCT_STATISTICS' | translate }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'USERS.USERS_PROFILE.CARD_SUBTITLE' | translate }}</h6>
        <p class="card-text">{{ 'USERS.USERS_PROFILE.SOME_TEXT' | translate }}.</p>
        <a href="#" class="card-link">{{ 'USERS.USERS_PROFILE.CARD_LINK' | translate }}</a>
        <a href="#" class="card-link">{{ 'USERS.USERS_PROFILE.CARD_LINK_ANT' | translate }}</a>
      </div>
    </div>

  </div>
</div>



